<template>
  <div :class="$style.card">
    <div :class="$style.top">
      <div :class="$style.number">{{ order.number }}</div>
      <div :class="$style.done">Выполнен</div>
    </div>
    <div :class="$style.bottom">
      <div :class="$style.car">
        <img
          v-if="order.car?.make?.logo"
          :src="order.car?.make?.logo"
          alt=""
          :class="$style.img"
        />
        <span>{{ order.car?.make?.title }}</span>
      </div>
      <div v-if="order.car?.number" :class="$style.number">
        {{ order.car?.number }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoneOrderCard",
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" module>
.card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1.5rem;
  padding: 1.5rem;
  border-radius: 1rem;
  background-color: $dark-blue;
  overflow: hidden;
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 1;
}

.top,
.bottom {
  display: contents;
}

.top .number {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: $t-white;
}

.done {
  grid-column: 2;
  grid-row: 1;
  justify-self: end;
  color: $t-white;
  text-transform: uppercase;
  white-space: nowrap;
}

.car {
  grid-column: 1;
  grid-row: 2;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  color: $t-white;

  span {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .img {
    flex-shrink: 0;
    width: 3rem;
    height: 3rem;
    border-radius: 0.5rem;
    object-fit: cover;
  }
}

.bottom .number {
  grid-column: 2;
  grid-row: 2;
  justify-self: end;
  padding: 0.5rem;
  border: 1px solid $t-primary;
  border-radius: 2px;
  background-color: $bg-white;
  color: $t-primary;
  white-space: nowrap;
}
</style>
